import QuoteOpen from "@src/app/assets/icons/quote-open.svg?react";
import type { BFFArticleBodyElement } from "@src/app/types/bff";
import { useEffect, useState } from "react";

import ArticleAnnotation from "./components/ArticleAnnotation";

export default function ArticlePullQuote({
  element,
}: {
  element?: BFFArticleBodyElement["pull_quote"];
}) {
  const [pullQuote, setPullQuote] = useState("");
  const [hasDoubleQuote, setHasDoubleQuote] = useState(false);

  const startsWithDoubleQuote = (str: string): boolean => {
    const firstChar = str.trimStart().charAt(0);
    return firstChar === '"' || firstChar === "“" || firstChar === "”";
  };

  useEffect(() => {
    if (!element?.quote) return;

    const hasQuote = startsWithDoubleQuote(element.quote);
    setHasDoubleQuote(hasQuote);

    if (hasQuote) {
      // remove ASCII " or Unicode quotes “ ” and optional spaces after
      setPullQuote(element.quote.replace(/^["“”]\s*/, ""));
    } else {
      setPullQuote(element.quote);
    }
  }, [element]);

  return (
    <div className="border-divider-secondary dark:border-divider-secondary-on-dark mx-10 mb-4 min-w-0 flex-1 border-t border-b py-4 lg:mx-28">
      <div className="flex items-start gap-2">
        {hasDoubleQuote && (
          <div className="text-icon-brand">
            <QuoteOpen width={28} height={28} />
          </div>
        )}

        <p className="text-header-3 py-1">
          <ArticleAnnotation
            value={pullQuote}
            annotations={element?.quoteAnnotations || []}
          />
        </p>
      </div>
    </div>
  );
}
